
import { handleError } from '@/plugins/helper'
import AuroraBackground from '~/components/common/aurora-background.vue'
import PageBottom from '~/components/common/page-bottom/index.vue'
import TextPressure from '~/components/common/text-pressure.vue'
import FooterNew from '~/components/FooterNew.vue'
import TextPressureMixin from '~/mixins/text-pressure.vue'
import RelatedArticles from '~/sections/vision/ai-workspace/related-articles.vue'
import VisionChildKv from '~/sections/vision/child-kv.vue'
import AiProgram from '~/sections/vision/child-program.vue'

export default {
  components: {
    TextPressure,
    PageBottom,
    FooterNew,
    AuroraBackground,
    VisionChildKv,
    RelatedArticles,
    AiProgram
  },
  mixins: [TextPressureMixin],
  layout: 'home',
  async asyncData({ $content }) {
    const articles = await $content('article/all')
      .limit(4)
      .only(['url', 'thumbnail', 'thumbnailUrl', 'category', 'publicDateStr', 'title', 'media'])
      .fetch()
      .catch(handleError)

    return { articles: Array.isArray(articles) ? articles : [articles] }
  },
  data() {
    return {
      articles: []
    }
  },
  head() {
    const title = 'Community | VISION'
    const extendMeta = this.$helper.setMetaTitleAndDescription(title)

    return {
      title,
      meta: [...extendMeta]
    }
  }
}
